<style scoped lang="less">
.sms-content-main {
  background-color: #fff;
  border-radius: 10px;
}

.safe-result-top {
  display: flex;
  height: 50px;
  align-items: center;

  .safe-result-logo {
    display: inline-block;
    width: 21px;
    height: 40px;
    background: url("../../assets/safe-result-logo.png") no-repeat center;
    background-size: 100%;
    margin-left: 15px;
  }

  .safe-result-title {
    font-weight: bold;
    margin-left: 8px;
  }

  .year-wrapper {
    margin-left: 10px;

    .el-date-editor {
      width: 185px;
    }
  }
}

.safe-result-box {
  margin: 0 10px;

  .safe-result-main {
    display: flex;
    flex-wrap: wrap;

    & > div {
      padding: 0 20px;
      margin-bottom: 15px;
      box-sizing: border-box;
    }

    //图表统一高度
    /deep/ .chart-main {
      height: 250px;
    }

    //图表头部统一样式（名称、筛选组件等）
    /deep/ .chart-box-top {
      display: flex;
      height: 50px;
      align-items: center;

      .chart-select-container {
        flex: 1;
        display: flex;
        justify-content: flex-end;

        .el-select-wrapper:not(:last-child) {
          margin-right: 10px;
        }
      }

      .chart-title {
        font-weight: bold;
        font-size: 13px;
      }
    }
  }
}

//特殊调整
.chart-horizontal, .chart-trend, .chart-error, .chart-accident-year {
  width: (100%/3);
}

.chart-accident-month {
  width: (100%/3*2);
}
</style>

<template>
  <div class="sms-content-main" v-title data-title="安全结果">
    <div class="safe-result-top">
      <div class="safe-result-logo"></div>
      <span class="safe-result-title">安全结果</span>
      <div class="el-date-picker-wrapper year-wrapper">
        <el-date-picker v-model="year" type="year" format="yyyy年" value-format="yyyy" :clearable="false"
                        :editable="false" placeholder="选择年份" :picker-options="pickerOptions">
        </el-date-picker>
      </div>
    </div>
    <div class="safe-result-box">
      <div class="safe-result-main">
        <div class="chart-horizontal">
          <SymptomHorizontal v-if="symptomOptions.length" :year="Number(year)" :company="company"
                             :symptom-options="symptomOptions"></SymptomHorizontal>
        </div>
        <div class="chart-trend">
          <SymptomTrend v-if="symptomOptions.length" :year="Number(year)" :company="company"
                        :symptom-options="symptomOptions"></SymptomTrend>
        </div>
        <div class="chart-error">
          <SeriousError :year="Number(year)" :company="company"></SeriousError>
        </div>
        <div class="chart-horizontal">
          <EventReasonHorizontal v-if="eventOptions.length" :year="Number(year)" :company="company"
                             :event-reason-options="eventOptions"></EventReasonHorizontal>
        </div>
        <div class="chart-trend">
          <EventReasonTrend v-if="eventOptions.length" :year="Number(year)" :company="company"
                        :event-reason-options="eventOptions"></EventReasonTrend>
        </div>
        <div class="chart-error">
          <SymptomHorizontal v-if="seriousOptions.length" :year="Number(year)" :company="company"
                             :symptom-options="seriousOptions" init-symptom="SR-009"
                             :chart-title="`${year}年航空集团各单位安全一类事件(含红线)统计`"></SymptomHorizontal>
        </div>
        <div class="chart-accident-year">
          <AccidentAnnual :year="Number(year)" :reload.sync="reloadAccident"></AccidentAnnual>
        </div>
        <div class="chart-accident-month">
          <AccidentMonth :year="Number(year)" :reload="reloadAccident"></AccidentMonth>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getRequest} from "../../utils/request";
import SymptomDetail from "./result/SymptomDetail";
import AccidentDetail from "./result/AccidentDetail";
import SymptomHorizontal from "./result/SymptomHorizontal";
import SymptomTrend from "./result/SymptomTrend";
import EventReasonHorizontal from "./result/EventReasonHorizontal";
import EventReasonTrend from "./result/EventReasonTrend";
import SeriousError from "./result/SeriousError";
import AccidentAnnual from "./result/AccidentAnnual";
import AccidentMonth from "./result/AccidentMonth";

export default {
  props: {
    //航司代码，为当前用户的所属航司
    company: String,
  },
  data() {
    return {
      //默认今年
      year: String(new Date().getFullYear()),
      //可选择的征候
      symptomOptions: [],
      seriousOptions: [],
      eventOptions: [],
      pickerOptions: {
        //限制用户可选历史年度最早到2019年。
        disabledDate: time => {
          return time.getTime() < new Date(2020, 0);
        }
      },
      //重新加载民航事故图表
      reloadAccident: true,
    };
  },
  mounted() {
    this.buildSymptomOptions();
    this.buildSeriousOptions();
    this.buildEventReasonOptions();
  },
  methods: {
    /**
     * 严重等级选项
     */
    buildSymptomOptions() {
      getRequest("/result/symptom/options")
        .then(res => {
          this.symptomOptions = res.data;
        })
    },

    /**
     * 严差选项
     */
    buildSeriousOptions() {
      getRequest("/result/error/options")
        .then(res => {
          this.seriousOptions = res.data;
        })
    },

    /**
     * 事件原因选项
     */
    buildEventReasonOptions() {
      getRequest("/result/symptom/event/options")
        .then(res => {
          this.eventOptions = res.data;
          console.log(this.eventOptions)
        })
    },
  },
  components: {
    SymptomDetail, AccidentDetail, SymptomHorizontal, SymptomTrend, SeriousError,
    EventReasonHorizontal, EventReasonTrend,
    AccidentAnnual, AccidentMonth
  }
}
</script>



// WEBPACK FOOTER //
// src/components/achievement/SafeResult.vue